import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Close from '../../../Icons/24x24/Close';
import IconButton from '../../../Buttons/IconButton';
import ModalCloseContext from '../../context';

interface Props {
  className?: string;
}

const ModalCloseButton: React.FC<Props> = ({ className }) => {
  const { t } = useTranslation();
  const handleClose = useContext(ModalCloseContext);
  return (
    <IconButton
      className={className}
      size="large"
      aria-label={t('common.close')}
      icon={Close}
      onClick={handleClose}
    />
  );
};

ModalCloseButton.displayName = 'ModalCloseButton';

export default ModalCloseButton;
